import React, { FC, useState }         from "react";
import { useDispatch, useSelector }    from "react-redux";
import { Button, Header, Icon, Modal } from "semantic-ui-react";
import DeleteCustomer                  from "../../../application/usecase/customer/DeleteCustomer";
import Customer                        from "../../../domain/customer/Customer";
import Customers                       from "../../../domain/customer/Customers";
import { ResKaState }                  from "../../../index";
import { apiGetCustomerHasAccount }    from "../../../infrastructure/api/customer";

interface Props {
  customer: Customer;
}

const CustomerDeleteButton: FC<Props> = (props: Props) => {
  const {customer} = props;
  const [open, setOpen] = useState(false);
  const [hasAccount, setHasAccount] = useState(false);
  const customers: Customers = useSelector((state: ResKaState) => state.customers);
  const deleteCustomer: DeleteCustomer = new DeleteCustomer(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        negative
        onClick={ () => {
          setOpen(true);
          apiGetCustomerHasAccount(customer.id).then(value => setHasAccount(value));
        } }
      >
        <Icon name="trash"/>
        削除する
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>顧客削除の確認</Modal.Header>

        <Modal.Content>
          <Header
            as="h5"
            icon="info circle"
            dividing
            content={ `${ customer.detail.name.lastName.value } ${ customer.detail.name.firstName.value } を削除します。` }
            color="red"
          />
          {
            hasAccount
              ?
              <>
                <p>この顧客はWEB予約ページのログインアカウントが作成されています。</p>
                <p>削除するとWEB予約ページのログインアカウントも削除されますが、よろしいですか？</p>
              </>
              :
              <>
                <Modal.Description>
                  <p>よろしいですか？</p>
                </Modal.Description>
              </>
          }
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={ () => setOpen(false) }>
            閉じる
          </Button>

          <Button
            icon
            labelPosition="left"
            negative
            onClick={ () => {
              deleteCustomer.execute(customer.id, customers.pagination.current, customers.search, customers.sortType);
              setOpen(false);
            } }
          >
            <Icon name="trash"/>
            削除する
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default CustomerDeleteButton;
